var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgUg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7303_38729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9434 20C22.8439 17.8769 24 15.0737 24 12C24 8.92631 22.8438 6.12304 20.9434 3.99998L12 3.13045L3.05663 3.99998C1.15617 6.12304 0 8.92631 0 12C0 15.0737 1.15613 17.8769 3.05658 20L12 20.8695L20.9434 20Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.05664 3.99998H20.9434C18.7462 1.54528 15.5537 0 12 0C8.44628 0 5.25386 1.54528 3.05664 3.99998Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12L12 13.0435L24 12C24 10.5973 23.7585 9.25116 23.3162 7.99997H0.683813C0.241453 9.25116 0 10.5973 0 12H0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.683813 16H23.3163C23.7585 14.7488 24 13.4027 24 12H0C0 13.4027 0.241453 14.7488 0.683813 16V16Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9435 20H3.05664C5.25386 22.4547 8.44628 24 12.0001 24C15.5538 24 18.7463 22.4547 20.9435 20Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0043 12C16.0043 14.2117 14.2117 16.0043 11.9999 16.0043C9.78825 16.0043 7.99561 14.2117 7.99561 12C7.99561 9.78829 9.78825 7.99565 11.9999 7.99565C14.2117 7.99565 16.0043 9.78829 16.0043 12Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4669 12.2042L11.9999 11.5685C11.9999 11.5685 12.3431 10.4293 12.3614 10.3514C12.3748 10.2944 12.3819 10.235 12.3819 10.174C12.3819 9.95785 12.2943 9.76219 12.1526 9.62063L12.5215 9.25172C12.2855 9.01571 11.9594 8.86969 11.5992 8.86969C11.239 8.86969 10.9129 9.01566 10.6769 9.25172L11.0458 9.62063C10.9042 9.76224 10.8166 9.95789 10.8166 10.174C10.8166 10.253 10.8285 10.3292 10.8503 10.4011L10.2949 10.9565H11.3044C11.3044 10.9565 10.887 11.5834 10.6592 12.0983C10.4313 12.613 10.6623 13.2415 11.1889 13.4756L11.4934 13.6109L11.9999 14.087V14.6087L11.4782 15.1304H12.5217V14.0869L12.9978 13.6108H13.9825C13.9873 13.601 13.9922 13.5915 13.9967 13.5814C14.2307 13.0549 13.9935 12.4382 13.4669 12.2042Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7303_38729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUg);
export default __webpack_public_path__ + "static/media/ug.1e55de2101ee5a1f498b362560bb57a6.svg";
export { ForwardRef as ReactComponent };